import { mixSort } from '@/utils/bussiness'
import { State } from './state'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import en from 'element-plus/es/locale/lang/en'
import { ReviewStatus, ReviewStatusLabelMap } from '@/constants/metadata'
import { ComputedRef, computed } from 'vue'

export default {
  aspectRatio(state: State) {
    return state.mode === '916' ? 9 / 16 : 16 / 9
  },
  sortedProjects(state: State) {
    const topProjects = state.projects
      .filter((i) => i.is_top)
      .sort((i, j) => mixSort(i.name, j.name))
      .sort((i, j) => j.order - i.order)
    return topProjects.concat(state.projects.filter((i) => !i.is_top).sort((i, j) => mixSort(i.name, j.name)))
  },
  locale(state: State) {
    return state.language === 'zh-cn' ? zhCn : en
  },
  reviewStatusOptions(state: State) {
    const options = []
    state.audits.forEach(i => {
      !i.disable && options.push({
        label: i.type === 'custom' ? i.displayName : ReviewStatusLabelMap[i.key as ReviewStatus].value || i.displayName,
        value: i.key
      })
    })
    options.push({
      label: ReviewStatusLabelMap[''].value,
      value: ''
    })

    return options
  },
  enableAudits (state: State) {
    return state.audits.filter(i => !i.disable)
  },
  reviewStatusLabelMap(state: State) {
    const map = new Map<string, ComputedRef<string>>()
    state.audits.forEach(i => {
      map.set(i.key, i.type === 'custom' ? computed(() => i.displayName) : ReviewStatusLabelMap[i.key as ReviewStatus] || i.displayName)
    })
    map.set('', ReviewStatusLabelMap[''])
    return map
  },
  reviewStatusColorMap(state: State) {
    const map = new Map<string, string>()
    state.audits.forEach(i => {
      map.set(i.key, i.color)
    })
    map.set('', 'white')
    return map
  }
}
